import React from 'react'

import {IoLocationSharp} from 'react-icons/io5'

import {MdOutlineSupportAgent} from 'react-icons/md'
import {AiOutlineMail} from 'react-icons/ai'
import Footer from '../Footer/Footer'

import { NavLink } from 'react-router-dom'
import Header from '../Header/Header'


const Help = () => {
  return (
    < >

    <Header/>

    <section style={{paddingTop:'130px'}}>
     <div className='container'>
      <div className='row'>
       <div className='col-lg-12 col-sm-12'>
          
        <h1 className='text-center'> We are here to Help.<br/> 24*7</h1>

       </div>
      </div>
     </div>
     </section>




     <section>
      <div className='container mt-3'>
       <div className='row'> 
     
       <div className='col-lg-4 col-md-6 col-sm-12 mt-3'>
       <NavLink  to='tel:1020305040' style={{textDecoration:'none', color:'#000'}}>  
       <div> 
       <h5 className='py-2' style={{textAlign:'center',border:'1px solid #000',    borderRadius:'10px' }}> <MdOutlineSupportAgent style={{fontSize:'32px'}}/>  Talk to our Executives</h5>
       </div>
</NavLink>
       </div>



       <div className='col-lg-4 col-md-6 col-sm-12 mt-3'>
       <NavLink  to='mailto: abc@example.com' style={{textDecoration:'none', color:'#000'}}>
       <div > 
       <h5 className=''  style={{textAlign:'center',border:'1px solid #000', borderRadius:'10px', padding:'12px 10px' }}> <AiOutlineMail className='pb-1' style={{fontSize:'25px'}}/>  Write Mail to Us</h5>
       </div>
        </NavLink>
       </div>

       <div className='col-lg-4 col-md-6 col-sm-12 mt-3'>
  
       <NavLink  to='https://goo.gl/maps/aUWWgJ4HWDN3cFLW7' style={{textDecoration:'none', color:'#000'}}>
       <div> 
       <h5 className=' '  style={{textAlign:'center',border:'1px solid #000', borderRadius:'10px', padding:'12px 10px'}}> <IoLocationSharp style={{fontSize:'24px'}}/>  Visit our Office</h5>
       </div>
  </NavLink>


       </div>

      </div>
      </div>
     </section>


     <section>
      <div className='container '>
       <div className='row'>
        <div className='col-lg-12 col-sm-12 mt-5'>
         
        <h2 className='text-center'>Frequently Asked Questions</h2>
        </div>

          
        <div className='col-lg-7 col-sm-12 m-auto mt-4'>
          <div className='row'>
            
          <div className='col-lg-12 col-sm-12 '>
             
          <div class="accordion" id="accordionExample"  >
  <div class="accordion-item" style={{border:'none', border:'1px solid #DBDBDB', borderRadius:'5px'}}>
    <h2 class="accordion-header" id="headingOne">
      <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne" style={{boxShadow:'none',fontWeight:'600'}}>
      Does IntelliX provides 24*7 Technical Support in Free Plan?
      </button>
    </h2>
    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
      <div class="accordion-body">
         <p> Yes, IntelliX 360, a SaaS-based hyper automation solution for educational enterprises, provides 247 technical support even in its free plan. Our team of technical experts is always available to assist our customers with there queries and concerns via email and voice call. We understand the importance of uninterrupted service and strive to provide our customers with the best possible support at all times. Whether it is a technical issue or a general query, our support team is well-equipped to provide prompt and effective solutions. So, if you are using IntelliX 360's free plan, you can rest assured that you will have access to 247 technical support whenever you need it.</p>
      </div>
    </div>
  </div>
  <div class="accordion-item  mt-3" style={{border:'none', border:'1px solid #DBDBDB'}}>
    <h2 class="accordion-header" id="headingTwo">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" style={{boxShadow:'none',fontWeight:'600'}}>
      Are there any type of Hidden Charges for IntelliX services ?
      </button>
    </h2>
    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        <p>No, IntelliX does not have any hidden charges for its services. We believe in transparency and providing our customers with clear and upfront pricing for our services. Our pricing plans are designed to offer a range of features and benefits at competitive rates, and we do not have any hidden fees or charges. When you sign up for IntelliX services, you can be assured that you will only be charged for the services that you have subscribed to, without any surprise costs. We understand that hidden charges can be frustrating and can erode the trust that customers have in a business. Therefore, we are committed to being transparent and honest in our pricing, and providing our customers with a seamless and hassle-free experience.</p>
      </div>
    </div>
  </div>
  <div class="accordion-item mt-3 " style={{border:'none', border:'1px solid #DBDBDB', borderRadius:'8px'}}>
    <h2 class="accordion-header" id="headingThree">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" style={{boxShadow:'none',fontWeight:'600'}}>
      What is IntelliX ?
      </button>
    </h2>
    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
      <div class="accordion-body">
     <p>IntelliX is a SaaS-based hyper automation solution designed specifically for educational enterprises. It is an innovative platform that enables educational institutions to automate there administrative tasks and streamline there operations. IntelliX offers a wide range of features such as student information management, attendance tracking, fee management, online exams, and much more. With its user-friendly interface and powerful automation capabilities, IntelliX can help educational institutions to save time, reduce manual errors, and increase efficiency. IntelliX is constantly evolving to meet the changing needs of the education industry, and we are committed to providing our customers with the best possible experience.</p>
      </div>
    </div>
  </div>








  <div class="accordion-item mt-3 " style={{border:'none', border:'1px solid #DBDBDB', borderRadius:'8px'}}>
  <h2 class="accordion-header" id="headingfor">
    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefor" aria-expanded="false" aria-controls="collapsefor" style={{boxShadow:'none',fontWeight:'600'}}>
    Who is Behind intelliX ?
    </button>
  </h2>
  <div id="collapsefor" class="accordion-collapse collapse" aria-labelledby="headingfor" data-bs-parent="#accordionExample">
    <div class="accordion-body">
   <p>The founding team behind IntelliX includes Mr. Harsh Kadyan, Mr. Santosh Kumar Yadav, and Mr. Nand Kishor Yadav. Mr. Harsh Kadyan brings expertise in product designing and business operations, and he played a key role in designing the entire platform and conducting market research.<br/> Mr. Santosh Kumar Yadav and Mr. Nand Kishor Yadav also serve as founders of IntelliX, and they have a wealth of experience in the education industry. Together, the founding team has a shared vision of transforming the way educational institutions operate, by leveraging the power of automation and technology. Their combined expertise and passion for innovation have driven the development of IntelliX into a leading hyper automation solution for educational enterprises.</p>
    </div>
  </div>
</div>






  <div class="accordion-item mt-3 " style={{border:'none', border:'1px solid #DBDBDB', borderRadius:'8px'}}>
  <h2 class="accordion-header" id="headingfiv">
    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefiv" aria-expanded="false" aria-controls="collapsefor" style={{boxShadow:'none',fontWeight:'600'}}>
    If I face any type of issue, then whom I will contact ?
    </button>
  </h2>
  <div id="collapsefiv" class="accordion-collapse collapse" aria-labelledby="headingfiv" data-bs-parent="#accordionExample">
    <div class="accordion-body">
   <p>If you face any type of issue with IntelliX, there are several ways to get in touch with our support team. We offer a toll-free number that is available 24x7, so you can reach out to us at any time if you require assistance. In addition, you can also send an email to our support team at support@intellix360.com, and our technical experts will get back to you as soon as possible.<br/>

   Furthermore, we provide our customers with dedicated relationship managers who can assist them during business hours. These managers are knowledgeable about our platform and can provide personalized support to help resolve any issues or queries that you may have. Our goal is to ensure that our customers have a seamless experience with IntelliX, and our support team is always available to help them achieve this. So, whether you need technical assistance or have general questions about our platform, our support team is here to help.</p>
    </div>
  </div>
</div>



  <div class="accordion-item mt-3 " style={{border:'none', border:'1px solid #DBDBDB', borderRadius:'8px'}}>
  <h2 class="accordion-header" id="headingsix">
    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsesix" aria-expanded="false" aria-controls="collapsefor" style={{boxShadow:'none',fontWeight:'600'}}>
    Is my Data Secured on IntelliX ?
    </button>
  </h2>
  <div id="collapsesix" class="accordion-collapse collapse" aria-labelledby="headingsix" data-bs-parent="#accordionExample">
    <div class="accordion-body">
   <p>Yes, your data is secured on IntelliX. We understand the importance of data security and take all necessary measures to ensure that your data is protected at all times. To achieve this, we have implemented a triple layer of data encryption, which ensures that your data is encrypted both in transit and at rest.<br/>

   When you use IntelliX, all data that is transmitted over the internet is encrypted using industry-standard TLS/SSL encryption protocols, which provides an additional layer of security. Furthermore, we also use robust encryption algorithms to encrypt your data at rest, which means that your data is secure even when it is stored in our servers.<br/>
   
   We also have strict access controls in place, which ensure that only authorized personnel have access to your data. Our team of technical experts follows industry best practices for data security, including regular security audits and penetration testing, to ensure that our platform is secure and free from vulnerabilities.<br/>
   
   In addition to these measures, we also provide our customers with regular backups of there data, so that they can recover there data in case of any unforeseen events. Our commitment to data security is an integral part of our platform, and we strive to provide our customers with a secure and hassle-free experience with IntelliX.</p>
    </div>
  </div>
</div>


  <div class="accordion-item mt-3 " style={{border:'none', border:'1px solid #DBDBDB', borderRadius:'8px'}}>
  <h2 class="accordion-header" id="headingseven">
    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseseven" aria-expanded="false" aria-controls="collapseseven" style={{boxShadow:'none',fontWeight:'600'}}>
    How long does it take to get onboarded on IntelliX ?
    </button>
  </h2>
  <div id="collapseseven" class="accordion-collapse collapse" aria-labelledby="headingsix" data-bs-parent="#accordionExample">
    <div class="accordion-body">
   <p> If you sign up for IntelliX's free plan, you can start using our platform instantly with minimal features that do not require KYC process, such as student addition, course creation, and content creation. This means that you can get onboarded on our platform in a matter of minutes and start exploring its capabilities.<br/>

   However, if you require access to the complete range of features that IntelliX offers, it may take up to 30 working days to get onboarded. This is because our team needs to set up the platform for your specific requirements, and may also need to deploy hardware in your institution. Additionally, we may require KYC documents from your institution to ensure that all users on our platform are authorized to access the data.<br/>
   
   Our team will work closely with you to ensure that the onboarding process is as smooth as possible, and we will keep you informed at every step of the way. Our goal is to ensure that you have a hassle-free experience with IntelliX, and we will do everything we can to get you up and running as quickly as possible.</p>
    </div>
  </div>
</div>





  <div class="accordion-item mt-3 " style={{border:'none', border:'1px solid #DBDBDB', borderRadius:'8px'}}>
  <h2 class="accordion-header" id="headingnine">
    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsenine" aria-expanded="false" aria-controls="collapsenine" style={{boxShadow:'none', fontWeight:'600'}}>
   Does IntelliX provides Education Loan ?
    </button>
  </h2>
  <div id="collapsenine" class="accordion-collapse collapse" aria-labelledby="headingnin" data-bs-parent="#accordionExample">
    <div class="accordion-body">
   <p>Yes, IntelliX 360 provides student education loans to eligible students in qualified scenarios. We understand that financing education can be a challenge for many students, and we are committed to providing affordable and accessible education to all.<br/>

   Our student education loans come with a 0% interest rate in some qualified scenarios, making them an affordable option for students who need financial assistance. To apply for a student education loan from IntelliX 360, you can get in touch with our support team, who will guide you through the application process and provide you with all the necessary information.<br/>
   
   Our student education loans are designed to be flexible and cater to the unique needs of each student. We offer a range of repayment options, including deferred repayment, interest-only payments, and fixed monthly payments, so that students can choose the option that works best for them.<br/>
   
   At IntelliX 360, we are committed to providing a comprehensive education ecosystem that includes not only our platform but also financial support to eligible students who need it. If you require financial assistance to pursue your education, please reach out to our support team to explore your options.</p>
    </div>
  </div>
</div>



  <div class="accordion-item mt-3 " style={{border:'none', border:'1px solid #DBDBDB', borderRadius:'8px'}}>
  <h2 class="accordion-header" id="headingten">
    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseten" aria-expanded="false" aria-controls="collapseeig" style={{boxShadow:'none', fontWeight:'600'}}>
    What are the Documents Required for the onboarding process ?
    </button>
  </h2>
  <div id="collapseten" class="accordion-collapse collapse" aria-labelledby="headingten" data-bs-parent="#accordionExample">
    <div class="accordion-body">
   <p>To onboard your educational institute on IntelliX, we require certain KYC (Know Your Customer) documents to ensure that all users on our platform are authorized to access the data. These documents are required as a part of the verification process and help us maintain the security and integrity of our platform.<br/>

   The general list of KYC documents required for the onboarding process includes:
   
   Certificate of incorporation/Registration Certificate of the educational institute
   PAN card of the institute
   Identity proof of the authorized signatory
   Address proof of the authorized signatory
   Bank statement for the last 6 months
   GST certificate (if applicable)
   Other relevant documents as required by IntelliX
   Apart from these documents, educational institutes located in India will also need to provide additional documents required for Payment Gateway verification process. These documents may include:
   <br/>
   Board resolution
   Company's TAN
   Cancelled cheque leaf
   Company's GST registration certificate (if applicable)
   Aadhaar card and PAN card of the authorized signatory
   Website URL where payment gateway is to be integrated
   Other documents as required by the payment gateway provider
   Our team will guide you through the entire onboarding process and provide you with all the necessary information regarding the required documents. We strive to make the onboarding process as seamless as possible, and our team is always available to answer any questions or concerns that you may have. </p>
    </div>
  </div>
</div>




  <div class="accordion-item mt-3  " style={{border:'none', border:'1px solid #DBDBDB', borderRadius:'8px'}}>
  <h2 class="accordion-header" id="headingott">
    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseott" aria-expanded="false" aria-controls="collapseott" style={{boxShadow:'none', fontWeight:'600'}}>
    What is the benefit of using IntelliX 360 over other CRMs/ERPs ?
    </button>
  </h2>
  <div id="collapseott" class="accordion-collapse collapse" aria-labelledby="headingott" data-bs-parent="#accordionExample">
    <div class="accordion-body">
   <p>IntelliX 360 is a unique platform that offers several benefits over other CRMs/ERPs available in the market. One of the most significant advantages of using IntelliX 360 is the power of Hyperautomation and AI that we have integrated into our platform. This technology makes our platform more efficient, intelligent, and user-friendly, providing users with an unparalleled experience.<br/>

   Hyperautomation is the combination of Robotic Process Automation (RPA) and Artificial Intelligence (AI) technologies that automate complex business processes. With IntelliX 360, educational institutions can streamline there operations, reduce manual effort, and improve overall efficiency. The platform's AI algorithms and machine learning capabilities can learn from user interactions and improve the system's performance over time.<br/>
   
   IntelliX 360 offers several other benefits over other CRMs/ERPs available in the market, including:
   
   Complete Education Ecosystem - IntelliX 360 offers a complete education ecosystem that includes features for student management, course management, content creation, and examination management.
   
   Customizable Dashboard - Our platform provides a customizable dashboard that allows educational institutions to create a personalized experience for there users.<br/>
   
   Real-Time Analytics - With IntelliX 360, institutions can track there performance in real-time, enabling them to make informed decisions.<br/>
   
   Scalable and Flexible - Our platform is scalable and flexible, meaning it can adapt to the needs of any educational institution, regardless of size or complexity.<br/>
   
   User-Friendly Interface - IntelliX 360 provides a user-friendly interface that is easy to use and requires minimal training.<br/>
   
   In summary, IntelliX 360 offers several unique features and benefits that make it a superior platform to other CRMs/ERPs available in the market. Our platform's power of Hyperautomation and AI technology, coupled with its complete education ecosystem, customizable dashboard, real-time analytics, scalability, and user-friendly interface, make it an ideal solution for educational institutions looking to streamline there operations and improve there overall efficiency. </p>
    </div>
  </div>
</div>



  <div class="accordion-item mt-3  " style={{border:'none', border:'1px solid #DBDBDB', borderRadius:'8px'}}>
  <h2 class="accordion-header" id="headingdemo">
    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsedemo" aria-expanded="false" aria-controls="collapsedemo" style={{boxShadow:'none', fontWeight:'600'}}>
    How can IntelliX 360 improve the quality of Education ? 
    </button>
  </h2>
  <div id="collapsedemo" class="accordion-collapse collapse" aria-labelledby="headingdemo" data-bs-parent="#accordionExample">
    <div class="accordion-body">
   <p>IntelliX 360 can significantly improve the quality of education by providing educational institutions with a complete ecosystem that streamlines there operations, reduces manual effort, and improves overall efficiency. Here are some ways IntelliX 360 can help improve the quality of education:<br/>

   Personalized Learning Experience - With IntelliX 360, institutions can create a personalized learning experience for there students. The platform offers features like content creation, course management, and examination management that enable institutions to tailor there approach to meet individual student needs.<br/>
   
   Improved Communication - IntelliX 360 provides a centralized platform for all communication between students, teachers, and parents. This ensures that everyone is on the same page and has access to the same information, leading to improved communication and collaboration.<br/>
   
   Real-Time Analytics - IntelliX 360 provides real-time analytics that enable institutions to track there performance and identify areas for improvement. This helps institutions make data-driven decisions that can lead to better learning outcomes.<br/>
   
   Efficient Administration - With IntelliX 360, institutions can automate several administrative tasks, reducing manual effort and improving overall efficiency. This allows educators to focus on teaching and student engagement, which can significantly improve the quality of education.<br/>
   
   Hyperautomation and AI - IntelliX 360 leverages the power of hyperautomation and AI technology, which can automate complex business processes and help institutions identify patterns and insights that can improve there operations.<br/>
   
   In summary, IntelliX 360 can improve the quality of education by providing educational institutions with a complete ecosystem that streamlines there operations, improves communication, provides real-time analytics, automates administrative tasks, and leverages the power of hyperautomation and AI technology. By using IntelliX 360, educational institutions can focus on delivering quality education to there students while improving there overall efficiency and effectiveness.</p>
    </div>
  </div>
</div>
 



</div>
          </div>
          </div>
        </div>
          
       </div>
      </div>
     </section>



     <section className='mt-5'> 
     <div>
     <Footer/>
     </div>
     
     </section>

    </>
  )
}

export default Help
